import React from 'react';
import { compose, withProps, withHandlers } from 'recompose';
import './SearchInput.css';

const SearchInput = ({
  clearClass,
  placeholder,
  value,
  handleChange,
  handleClear,
  onKeyDown,
}) => (
  <div className="SearchInput">
    <div className="fontawesome-search" />
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      onKeyDown={onKeyDown}
    />
    <button className={clearClass} onClick={handleClear}>
      <div className="fontawesome-remove" />
    </button>
  </div>
);

export default compose(
  withProps(({ value }) => ({
    clearClass: !value || value.length === 0 ? 'hide' : undefined,
  })),
  withHandlers({
    handleChange: ({ onChange }) => event =>
      onChange && onChange(event.target.value),
    handleClear: ({ onClear }) => () =>
      onClear && onClear(),
  }),
)(SearchInput);



// WEBPACK FOOTER //
// ./src/components/SearchInput/SearchInput.jsx